import _classCallCheck from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { EventEmitter } from "events";
import { _makeEmitter } from "./emitter";
import { SubscriptionState } from "./subscription-state";
/**
 * A subscription provides {@link Notification} of events.
 *
 * @remarks
 * See {@link Subscriber} for details on establishing a subscription.
 *
 * @public
 */

export var Subscription = /*#__PURE__*/function () {
  /**
   * Constructor.
   * @param userAgent - User agent. See {@link UserAgent} for details.
   * @internal
   */
  function Subscription(userAgent) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Subscription);

    this._disposed = false;
    this._state = SubscriptionState.Initial;
    this._stateEventEmitter = new EventEmitter();
    this._logger = userAgent.getLogger("sip.Subscription");
    this._userAgent = userAgent;
    this.delegate = options.delegate;
  }
  /**
   * Destructor.
   */


  _createClass(Subscription, [{
    key: "dispose",
    value: function dispose() {
      if (this._disposed) {
        return Promise.resolve();
      }

      this._disposed = true;

      this._stateEventEmitter.removeAllListeners();

      return Promise.resolve();
    }
    /**
     * The subscribed subscription dialog.
     */

  }, {
    key: "stateTransition",

    /** @internal */
    value: function stateTransition(newState) {
      var _this = this;

      var invalidTransition = function invalidTransition() {
        throw new Error("Invalid state transition from ".concat(_this._state, " to ").concat(newState));
      }; // Validate transition


      switch (this._state) {
        case SubscriptionState.Initial:
          if (newState !== SubscriptionState.NotifyWait && newState !== SubscriptionState.Terminated) {
            invalidTransition();
          }

          break;

        case SubscriptionState.NotifyWait:
          if (newState !== SubscriptionState.Subscribed && newState !== SubscriptionState.Terminated) {
            invalidTransition();
          }

          break;

        case SubscriptionState.Subscribed:
          if (newState !== SubscriptionState.Terminated) {
            invalidTransition();
          }

          break;

        case SubscriptionState.Terminated:
          invalidTransition();
          break;

        default:
          throw new Error("Unrecognized state.");
      } // Guard against duplicate transition


      if (this._state === newState) {
        return;
      } // Transition


      this._state = newState;

      this._logger.log("Subscription ".concat(this._dialog ? this._dialog.id : undefined, " transitioned to ").concat(this._state));

      this._stateEventEmitter.emit("event", this._state); // Dispose


      if (newState === SubscriptionState.Terminated) {
        this.dispose();
      }
    }
  }, {
    key: "dialog",
    get: function get() {
      return this._dialog;
    }
    /**
     * True if disposed.
     * @internal
     */

  }, {
    key: "disposed",
    get: function get() {
      return this._disposed;
    }
    /**
     * Subscription state. See {@link SubscriptionState} for details.
     */

  }, {
    key: "state",
    get: function get() {
      return this._state;
    }
    /**
     * Emits when the subscription `state` property changes.
     */

  }, {
    key: "stateChange",
    get: function get() {
      return _makeEmitter(this._stateEventEmitter);
    }
  }]);

  return Subscription;
}();